import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Agent, CreateAgentDto, UpdateAgentDto } from '../../models/forwarding/agent.model';

@Injectable({
  providedIn: 'root'
})
export class AgentService {
  private apiUrl = `${environment.apiUrl}/forwarding/agents`;
  private agentsSubject = new BehaviorSubject<Agent[]>([]);
  public agents$ = this.agentsSubject.asObservable();

  constructor(private http: HttpClient) {
    this.loadAgents();
  }

  private loadAgents(): void {
    console.log('[AgentService] Loading agents from:', this.apiUrl);
    this.http.get<Agent[]>(this.apiUrl).subscribe({
      next: (agents) => {
        console.log('[AgentService] Successfully loaded agents from API:', agents.length, agents);
        this.agentsSubject.next(agents);
      },
      error: (error) => {
        console.error('[AgentService] Error loading agents from API:', error);
        this.agentsSubject.next([]);
      }
    });
  }

  getAgents(): Observable<Agent[]> {
    return this.agents$;
  }

  getById(id: number): Observable<Agent> {
    return this.http.get<Agent>(`${this.apiUrl}/${id}`);
  }

  create(dto: CreateAgentDto): Observable<Agent> {
    return this.http.post<Agent>(this.apiUrl, dto).pipe(
      tap(() => {
        console.log('[AgentService] Agent created, reloading agents');
        this.loadAgents();
      })
    );
  }

  update(id: number, dto: UpdateAgentDto): Observable<Agent> {
    return this.http.put<Agent>(`${this.apiUrl}/${id}`, dto).pipe(
      tap(() => {
        console.log('[AgentService] Agent updated, reloading agents');
        this.loadAgents();
      })
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`).pipe(
      tap(() => {
        console.log('[AgentService] Agent deleted, reloading agents');
        this.loadAgents();
      })
    );
  }
}
